export default __webpack_public_path__ + "static/media/rocket-white.eb923cef.png";